namespace AgerLMS {
    export interface SiteSettings {
        SiteUrl?: string;
        PlatformTitle?: string;
        PlatformEmail?: string;
        PlatformPhone?: string;
        PlatformLogo?: string;
        FooterLogo?: string;
        PlatformFavicon?: string;
        BuyNowButton?: boolean;
        IsThereGuarantee?: boolean;
        GuaranteeText?: string;
        RegisterSmsText?: string;
        PlatformDescription?: string;
        GoogleSiteVerification?: string;
        AdditionalMetaTags?: string;
        AboutUsLink?: string;
        MembershipAgreementLink?: string;
        PrivacyAgreementLink?: string;
        DistanceSalesAgreementLink?: string;
        TermsOfUseLink?: string;
        PrivacyPolicyLink?: string;
        ContactUsLink?: string;
        FaqLink?: string;
        AccountInfoLink?: string;
    }
}
